import React from "react";

export default function IFrameSlice(slice) {
  return (
    <div className="iframe-slice">
      <div className="wrapper"><iframe title="iFrame Embed" src={slice.primary.iframe_url.url} /></div>
    </div>
  );
}